import transformMuiFilterToMongoDB from '@/services/utils/transformMuiFilterToMongoDB';
import { ButtonBase, Card } from '@mui/material';
import { DataGridPro, GridRow } from '@mui/x-data-grid-pro';
import { deDE } from '@mui/x-data-grid-pro/locales';
import { useEffect, useState } from 'react';

const RippleRow = (props) => (
  <ButtonBase focusRipple>
    <GridRow {...props} />
  </ButtonBase>
);

export default function ListCard({
  rows: data,
  columns,
  initialState,
  onRowClick,
  selectedRows,
  checkboxSelection = true,
  setSelectedRows,
  localeText = deDE.components.MuiDataGrid.defaultProps.localeText,
  loading,
  externalFilterModel,
  externalSortModel,
  externalColumnVisibilityModel,
  onColumnVisibilityChange,
  sx,
  refetch,
  livedata,
  headerFilters = false,
}) {
  const [sortModel, setSortModel] = useState(externalSortModel || []);
  const [filterModel, setFilterModel] = useState(
    externalFilterModel || { items: [] },
  );
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const [columnVisibilityModel, setColumnVisibilityModel] = useState(
    externalColumnVisibilityModel || {},
  );
  const [total, setTotal] = useState(data.length || 0);
  const [ids, setIds] = useState(null);

  useEffect(() => {
    if (externalFilterModel) setFilterModel(externalFilterModel);
  }, [externalFilterModel]);

  useEffect(() => {
    if (externalSortModel) setSortModel(externalSortModel);
  }, [externalSortModel]);

  useEffect(() => {
    if (externalColumnVisibilityModel)
      setColumnVisibilityModel(externalColumnVisibilityModel);
  }, [externalColumnVisibilityModel]);

  useEffect(() => {
    (async () => {
      if (!refetch) return;
      try {
        const filter = transformMuiFilterToMongoDB(filterModel);
        const sort = {};
        sortModel.forEach((s) => {
          sort[s.field] = s.sort === 'asc' ? 1 : -1;
        });
        const { total, result } = await refetch({
          sort,
          ...filter,
          limit: paginationModel.pageSize,
          skip: paginationModel.page * paginationModel.pageSize,
        });
        setTotal(total);
        setIds(result);
      } catch (error) {
        console.error('Fehler beim Abrufen der Daten:', error);
      }
    })();
  }, [sortModel, filterModel, paginationModel, livedata]);

  const rows = Array.isArray(ids)
    ? ids.map((id) => data.find((row) => row._id === id)).filter((row) => row)
    : data;

  return (
    <Card sx={sx}>
      <DataGridPro
        headerFilters={headerFilters}
        localeText={localeText}
        rows={rows}
        columns={columns}
        initialState={initialState}
        pageSizeOptions={[20, 50, 100]}
        checkboxSelection={checkboxSelection}
        loading={loading}
        slotProps={{
          loadingOverlay: {
            variant: 'skeleton',
            noRowsVariant: 'skeleton',
          },
        }}
        rowSelectionModel={{ ids: new Set(selectedRows), type: 'include' }}
        getRowId={(row) => row._id}
        onRowSelectionModelChange={(newSelection) => {
          setSelectedRows(Array.from(newSelection.ids || []));
        }}
        sx={{
          border: 0,
          '& .MuiDataGrid-cell': { cursor: 'pointer', pointerEvents: 'auto' },
          '& .MuiDataGrid-cellCheckbox': { cursor: 'default' },
          '& .MuiDataGrid-cell:focus': { outline: 'none' },
        }}
        onRowClick={onRowClick}
        onCellDoubleClick={() => {}}
        disableRowSelectionOnClick
        slots={{ row: RippleRow }}
        paginationModel={paginationModel}
        onSortModelChange={setSortModel}
        onFilterModelChange={(model) => setFilterModel(model)}
        onPaginationModelChange={setPaginationModel}
        columnVisibilityModel={columnVisibilityModel}
        onColumnVisibilityModelChange={(model) => {
          setColumnVisibilityModel(model);
          localStorage.setItem('toolsColumnVisibility', JSON.stringify(model));
          if (onColumnVisibilityChange) onColumnVisibilityChange(model);
        }}
        filterModel={filterModel}
        sortModel={sortModel}
        rowCount={refetch ? total : undefined}
        paginationMode={refetch ? 'server' : 'client'}
        filterMode={refetch ? 'server' : 'client'}
        sortingMode={refetch ? 'server' : 'client'}
        pagination
      />
    </Card>
  );
}
